"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableColumnConfigFactory = exports.TableStateFactory = exports.TableObjectStateFactory = exports.ITEMS_PER_PAGE_SHORT_OPTIONS = exports.ITEMS_PER_PAGE_OPTIONS_EXTENDED = exports.ITEMS_PER_PAGE_OPTIONS = exports.DEFAULT_ITEMS_PER_PAGE = exports.ITEMS_PER_PAGE = exports.SELECTION_TYPE = exports.PAGINATION = void 0;
var en_US_1 = __importDefault(require("@dtna/dvs-core-dcp-client-constants/lib/constants/en-US"));
var OPTION_LABELS = en_US_1.default.PAGINATION;
var DEFAULT_NUM_OF_CHAR_TO_SEARCH = 3;
var PAGINATION;
(function (PAGINATION) {
    PAGINATION["NONE"] = "none";
    PAGINATION["INFINITE_SCROLL"] = "infinite_scroll";
    PAGINATION["PAGING"] = "paging";
    PAGINATION["CURSOR"] = "cursor";
})(PAGINATION = exports.PAGINATION || (exports.PAGINATION = {}));
var SELECTION_TYPE;
(function (SELECTION_TYPE) {
    SELECTION_TYPE["CHECKBOX"] = "checkbox";
    SELECTION_TYPE["RADIOBUTTON"] = "radiobutton";
})(SELECTION_TYPE = exports.SELECTION_TYPE || (exports.SELECTION_TYPE = {}));
var ITEMS_PER_PAGE;
(function (ITEMS_PER_PAGE) {
    ITEMS_PER_PAGE[ITEMS_PER_PAGE["ITEMS_5"] = 5] = "ITEMS_5";
    ITEMS_PER_PAGE[ITEMS_PER_PAGE["ITEMS_10"] = 10] = "ITEMS_10";
    ITEMS_PER_PAGE[ITEMS_PER_PAGE["ITEMS_20"] = 20] = "ITEMS_20";
    ITEMS_PER_PAGE[ITEMS_PER_PAGE["ITEMS_50"] = 50] = "ITEMS_50";
    ITEMS_PER_PAGE[ITEMS_PER_PAGE["ITEMS_75"] = 75] = "ITEMS_75";
})(ITEMS_PER_PAGE = exports.ITEMS_PER_PAGE || (exports.ITEMS_PER_PAGE = {}));
exports.DEFAULT_ITEMS_PER_PAGE = ITEMS_PER_PAGE.ITEMS_20;
exports.ITEMS_PER_PAGE_OPTIONS = [
    {
        key: ITEMS_PER_PAGE.ITEMS_5,
        text: OPTION_LABELS.ITEMS_5,
    },
    {
        key: ITEMS_PER_PAGE.ITEMS_10,
        text: OPTION_LABELS.ITEMS_10,
    },
    {
        key: ITEMS_PER_PAGE.ITEMS_20,
        text: OPTION_LABELS.ITEMS_20,
    },
    {
        key: ITEMS_PER_PAGE.ITEMS_50,
        text: OPTION_LABELS.ITEMS_50,
    },
];
/**
 * Extended version of `ITEMS_PER_PAGE_OPTIONS`
 * includes 75 items per page option
 */
exports.ITEMS_PER_PAGE_OPTIONS_EXTENDED = __spreadArray(__spreadArray([], exports.ITEMS_PER_PAGE_OPTIONS, true), [
    {
        key: ITEMS_PER_PAGE.ITEMS_75,
        text: OPTION_LABELS.ITEMS_75,
    },
], false);
/**
 * Shorter version of `ITEMS_PER_PAGE_OPTIONS_EXTENDED`
 * includes only 20, 50, 75 items per page options
 */
exports.ITEMS_PER_PAGE_SHORT_OPTIONS = [
    {
        key: ITEMS_PER_PAGE.ITEMS_20,
        text: OPTION_LABELS.ITEMS_20,
    },
    {
        key: ITEMS_PER_PAGE.ITEMS_50,
        text: OPTION_LABELS.ITEMS_50,
    },
    {
        key: ITEMS_PER_PAGE.ITEMS_75,
        text: OPTION_LABELS.ITEMS_75,
    },
];
var TableObjectStateFactory = function (config) { return (__assign({ selectedRows: [], filters: {}, currentPage: 0, pageIsLoading: false }, config)); };
exports.TableObjectStateFactory = TableObjectStateFactory;
var TableStateFactory = function (config) { return (__assign({}, config)); };
exports.TableStateFactory = TableStateFactory;
var TableColumnConfigFactory = function (accessor, title, config) { return (__assign({ accessor: accessor, title: title, enableSorting: false, enableFiltering: false, minCharToSearch: DEFAULT_NUM_OF_CHAR_TO_SEARCH }, config)); };
exports.TableColumnConfigFactory = TableColumnConfigFactory;
